export interface BillingLevelOption {
  name: string;
  cost: number;
  level: number;
}

export const BILLINGLEVELOPTIONS: BillingLevelOption[] = [
  {
    name: 'Trial',
    cost: 0,
    level: 0,
  },
  {
    name: 'Standard',
    cost: 59.99,
    level: 1,
  },
  {
    name: 'Premium',
    cost: 84.99,
    level: 2,
  },
];
export enum BillingLevel {
  PREMIUM = 'Premium',
  STANDARD = 'Standard',
  TRIAL = 'Trial',
}
